"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var palette = {
  primary: {
    main: '#ff4c2e',
    body: '#414549',
    contrastText: '#fff'
  },
  secondary: {
    light: '#D7DFE6',
    main: '#B6C3CE',
    contrastText: '#fff'
  },
  accent: {
    orange: '#FF473E',
    blue: '#0095FF',
    yellow: '#f4bb00'
  },
  border: {
    main: '#DDE6EE',
    contrast: '#fff'
  },
  inputField: {
    border: '#95acbf',
    borderFocus: '#0C5390',
    borderHover: '#95acbf'
  },
  authereum: {
    darkBlue: '#00172B',
    mediumDarkBlue: '#00315C',
    blue: '#0C5390',
    mediumLightBlue: '#ABC2D7',
    lightBlue: '#E1EAF3',
    yellow: '#f4bb00',
    orange: '#ff4c2e',
    orangeHover: '#fb5438',
    lightOrange1: '#FF7C75',
    lightOrange2: '#FFA8A4',
    lightOrange3: '#FFDEDC',
    darkGrey: '#414549',
    mediumDarkGrey: '#778592',
    mediumLightGrey: '#C7D0D8',
    lightGrey: '#F2F6F9'
  }
};
exports.theme = {
  palette: palette,
  overrides: {
    MuiLink: {
      root: {
        color: palette.authereum.orange,
        fontWeight: 600
      }
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        boxShadow: 'none',
        padding: '0.5em 1.5em',
        fontWeight: '700',
        borderRadius: '100px',
        fontSize: '0.875em',
        '&$disabled': {
          background: 'rgba(0, 0, 0, 0.12)',
          color: 'rgba(0, 0, 0, 0.26)',
          boxShadow: 'none'
        }
      },
      contained: {
        boxShadow: 'none'
      },
      containedPrimary: {
        color: 'white',
        boxShadow: 'none',
        backgroundImage: 'linear-gradient(-134deg, #FF473E 1%, #FF6A63 100%)',
        '&:hover': {
          backgroundColor: palette.authereum.orangeHover,
          boxShadow: 'none'
        }
      },
      containedSecondary: {
        color: '#fff',
        boxShadow: 'none',
        background: '#ddd'
      }
    },
    MuiInputLabel: {
      root: {
        color: palette.secondary.main,
        '&$focused': {
          color: palette.authereum.blue
        }
      }
    },
    MuiInput: {
      root: {
        fontSize: '1.0em',
        color: palette.primary.body,
        '&:hover:not($disabled):not(.foo):not(.foo):not(.foo):before': {
          borderColor: palette.inputField.borderHover
        },
        '&:not(.foo)::before': {
          borderColor: palette.inputField.border
        },
        '&:not(.foo)::after': {
          borderColor: palette.inputField.borderFocus
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        fontSize: '1.0em',
        '&:hover:not(.foo):not(.foo):not(.foo) $notchedOutline': {
          borderColor: palette.inputField.borderHover
        },
        '&$focused:not(.foo):not(.foo):not(.foo) $notchedOutline': {
          borderColor: palette.inputField.borderFocus
        },
        '& $notchedOutline': {
          borderColor: palette.inputField.border
        }
      }
    },
    MuiFormHelperText: {
      root: {
        fontSize: '0.75em'
      }
    },
    MuiCardHeader: {
      root: {
        boxShadow: '0 10px 19px -7px rgba(92,118,153,0.15)'
      }
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        fontWeight: '600',
        fontSize: '0.875em'
      }
    },
    MuiPrivateTabIndicator: {
      root: {
        backgroundColor: palette.accent.orange
      },
      colorPrimary: {
        backgroundColor: palette.accent.orange
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: '0.875em'
      },
      dense: {
        fontSize: '0.875em'
      }
    },
    MuiFormLabel: {
      root: {
        fontSize: '1.0em'
      }
    },
    MuiSelect: {
      root: {
        fontSize: '1.0em'
      }
    },
    MuiIcon: {
      root: {
        fontSize: '1.5em'
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: '1.5em',
        '& svg': {
          fontSize: '1.5em'
        }
      }
    },
    MuiListItemIcon: {
      root: {
        fontSize: '1.6rem'
      }
    },
    MuiAutocomplete: {
      paper: {
        fontSize: '1.0em'
      }
    },
    MuiListSubheader: {
      root: {
        fontSize: '1.0em'
      }
    },
    MuiTableCell: {
      root: {
        fontSize: '1.4rem',
        '& button': {
          fontSize: '1.4rem'
        }
      }
    },
    MuiTypography: {
      h1: {
        fontWeight: 500,
        fontSize: '2.81em',
        '&.bold': {
          fontWeight: 800
        }
      },
      h2: {
        fontWeight: 500,
        fontSize: '1.88em',
        letterSpacing: '0.00625em',
        '&.bold': {
          fontWeight: 800
        }
      },
      h3: {
        fontWeight: 500,
        fontSize: '1.5em',
        letterSpacing: '0.00625em',
        '&.bold': {
          fontWeight: 800
        }
      },
      h4: {
        fontWeight: 500,
        fontSize: '1.13em',
        letterSpacing: '0.005625',
        '&.bold': {
          fontWeight: 800
        }
      },
      h5: {
        fontSize: '1.5em'
      },
      h6: {
        fontSize: '1.13em'
      },
      body1: {
        fontWeight: 500,
        fontSize: '0.94em',
        letterSpacing: '0.0125em',
        '&.bold': {
          letterSpacing: '0.00625em',
          fontWeight: 800
        }
      },
      body2: {
        fontWeight: 500,
        fontSize: '0.81em',
        letterSpacing: '0.005625em',
        '&.bold': {
          fontWeight: 800
        }
      },
      caption: {
        fontWeight: 500,
        fontSize: '0.6875em',
        letterSpacing: '0.061875em',
        textTransform: 'uppercase',
        '&.bold': {
          fontWeight: 700,
          letterSpacing: '0.05625em'
        }
      }
    },
    MuiTooltip: {
      tooltip: {
        fontSize: '0.8em'
      }
    }
  },
  typography: {
    useNextVariants: true,
    fontFamily: "\"Gothic A1\", \"Roboto\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""
  }
};
exports.default = exports.theme;